module.exports = __webpack_public_path__ + "static/media/shine.04fa60cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/dialog/shine.png
// module id = 698
// module chunks = 1